module.exports = __webpack_public_path__ + "img/shuffle.365a2a72.png";